import { EventMessage, EventType } from '@azure/msal-browser';
import { filter, take } from 'rxjs';

import { ChangeDetectorRef, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { TranslateService } from '@ngx-translate/core';
import {
  AuthService,
  LoggerService,
  SignalrService,
  TeamService,
} from '@oxypeak/commons';
import { DialogService } from './core/services/dialog.service';
import { LanguageService } from './core/services/language.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent {
  constructor(
    private signalRService: SignalrService,
    translate: TranslateService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    private authService: AuthService,
    private teamService: TeamService,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private cdRef: ChangeDetectorRef,
    private logger: LoggerService
  ) {
    translate.setDefaultLang('it');
    translate.use('it');
  }

  ngOnInit() {
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
        )
      )
      .subscribe((msg: EventMessage) => {
        //this.logger.debug('ACQUIRE_TOKEN_SUCCESS', msg);
        this.authService.setLoginStatus();
        if (!this.authService.isSuperAdmin()) {
          this.teamService.fetchUserTeam();
          const userTeamId = this.authService.getUserTeamId();
          if (userTeamId) this.signalRService.startConnection(userTeamId);
        }
      });

    this.authService.isLoggedIn$.pipe(take(1)).subscribe((__) => this.init());

    this.cdRef.detectChanges();
  }

  init() {
    // Other initialization logic if needed
  }
}
